import { Item } from '@/modules/items/types/itemTypes'
import { State } from '@/modules/items/store/itemsModule'

export const itemsTestingPanelGetters = {
	analysisAndStiItems(state: State): Item[] {
		return state.items.filter((i: Item) => i.attributes.is_analysis || i.attributes.is_sti)
	},
}
